import React from "react";
import PropTypes from "prop-types";

const VariantGroupsInformation = ({ variantGroups }) => {
  return (
    <div className="varsome-horiz-list-item">
      <div className="varsome-horiz-list-label">Variant groups</div>
      <div className="varsome-horiz-list-value">
        {variantGroups &&
          variantGroups.map((variantGroup) => {
            return (
              <span>
                <a href={`${variantGroup.variant_group_civic_url}}`}>
                  {variantGroup.group}
                </a>
                <div className="varsome-horiz-list-value">
                  {variantGroup.description}
                </div>
              </span>
            );
          })}
      </div>
    </div>
  );
};

VariantGroupsInformation.propTypes = {
  variantGroups: PropTypes.arrayOf(
    PropTypes.shape({
      group: PropTypes.string,
      group_details: PropTypes.shape({
        description: PropTypes.string,
        variant_group_civic_url: PropTypes.string,
      }),
    })
  ),
};

VariantGroupsInformation.defaultProps = {
  variantGroups: [],
};

export default VariantGroupsInformation;
